import styled from 'styled-components';
import BaseBackdrop from './BaseBackdrop';

const ModalBackdrop = styled(BaseBackdrop)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default ModalBackdrop;
